var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import { useMount } from 'react-use';
import { FileSystemDocumentDownloadFormat } from 'shared/domains/apollo/generated/types';
import { useActiveDocument } from 'shared/domains/documents';
import { PdfUrlDocument } from './PdfUrl.gql';
import { useLogoUrl } from '../useLogoUrl';
const FORMAT = FileSystemDocumentDownloadFormat.Pdf;
export function usePdfUrl() {
    var _a, _b;
    const { id: documentId } = useActiveDocument();
    const [mutate, mutateState] = useMutation(PdfUrlDocument);
    const [getLogoUrl, logoUrlState] = useLogoUrl(documentId);
    const url = (_b = (_a = mutateState.data) === null || _a === void 0 ? void 0 : _a.downloadFileSystemDocument.signed) === null || _b === void 0 ? void 0 : _b.url;
    const loading = mutateState.loading || logoUrlState.loading;
    const error = Boolean(mutateState.error || logoUrlState.error);
    const getPdf = () => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        try {
            const logoUrl = yield getLogoUrl();
            const appUrl = (_d = (_c = process.env.RENDER_SERVICE_CSS_FILE_APP_URL) !== null && _c !== void 0 ? _c : process.env.APP_URL) !== null && _d !== void 0 ? _d : window.location.origin;
            const cssUrl = new URL('/public/pdf.css', appUrl).toString();
            return yield mutate({
                variables: {
                    input: {
                        documentId,
                        cssUrl,
                        logoUrl,
                        downloadFormat: FORMAT,
                    },
                },
            });
        }
        catch (_e) {
            return null;
        }
    });
    useMount(getPdf);
    return { url, loading, error };
}
